import { Button, Form, Input, Flex } from "antd";
import { FORM_REQUIRED } from "../../../configs/configs";
import { useEffect, useState, useContext } from "react";
import useFetch from "../../../hooks/useFetch";
import { IndexContext } from "../../../context/IndexContext";

function SeuForm(props) {
  const {
    mode,
    siteID,
    setIsSeuFormModalOpen,
    refreshList,
    initialValues,
    setSelectedInfoSeu,
  } = props;

  const [fetchWrapper] = useFetch();

  const [seuForm] = Form.useForm();

  const [loadingSubmitButton, setLoadingSubmitButton] = useState(false);

  // load index context
  const { messageApi } = useContext(IndexContext);

  /* API to add seu */
  function addSeu(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "site_management/addSeu",
      body: {
        site_id: siteID,
        seu_name: user_inputs.Name,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsSeuFormModalOpen(false);
          seuForm.resetFields();
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
        setLoadingSubmitButton(false);
        refreshList();
      },
    });
  }

  /* API to edit seu */
  function editSeu(user_inputs) {
    setLoadingSubmitButton(true);
    fetchWrapper({
      endpoint_url: "site_management/editSeu",
      body: {
        seu_id: initialValues.ID,
        seu_name: user_inputs.Name,
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          messageApi.open({
            type: "success",
            content: fetch_output.message,
          });
          setIsSeuFormModalOpen(false);
          seuForm.resetFields();
          refreshList();
          setSelectedInfoSeu(null);
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
        setLoadingSubmitButton(false);
      },
    });
  }

  /* API to check whether seu name is unique */
  function checkUniqueSeuName(seu_name, callback) {
    fetchWrapper({
      endpoint_url: "site_management/checkUniqueSeuName",
      body: {
        site_id: siteID,
        seu_id: initialValues ? initialValues.ID : null,
        seu_name: seu_name ? seu_name : "",
      },
      onSuccess: (fetch_output) => {
        if (fetch_output.status === true) {
          if (fetch_output.is_unique === true) {
            callback(); // No error, so pass an empty callback
          } else {
            callback("SEU name already exists. Please input another SEU name.");
          }
        } else {
          messageApi.open({
            type: "error",
            content: fetch_output.error,
          });
        }
      },
    });
  }

  useEffect(() => {
    if (mode === "edit") {
      if (initialValues) {
        seuForm.setFieldsValue(initialValues);
      }
    }
  }, [mode, initialValues]);

  return (
    <>
      <Form
        form={seuForm}
        name="seu-form"
        labelCol={{
          span: 9,
        }}
        wrapperCol={{
          span: 15,
        }}
        onFinish={(values) => {
          if (mode === "add") {
            addSeu(values);
          } else {
            editSeu(values);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="SEU Name"
          name="Name"
          rules={[
            {
              required: FORM_REQUIRED,
              message: "SEU name cannot be empty.",
            },
            {
              validator: (_, value, callback) => {
                checkUniqueSeuName(value, callback);
              },
            },
          ]}
          validateTrigger="onBlur"
        >
          <Input />
        </Form.Item>

        <Flex justify="center">
          <Button
            className="mr-2"
            onClick={() => {
              setIsSeuFormModalOpen(false);
            }}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={loadingSubmitButton}
          >
            Submit
          </Button>
        </Flex>
      </Form>
    </>
  );
}

export default SeuForm;
